module.exports = __webpack_public_path__ + "img/stub-espn-topbar--l.93073b67.jpg";